// extracted by mini-css-extract-plugin
module.exports = {"base":"AnchorButton_base__35hey","primary":"AnchorButton_primary__3QBwI"};